import React from 'react';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const AGE_STORAGE_KEY = 'buzzed.ageVerified';

export function isAgeVerified() {
    try {
        return window.localStorage.getItem(AGE_STORAGE_KEY) === '1';
    } catch (e) {
        return false;
    }
}

function rememberAgeVerified() {
    try {
        window.localStorage.setItem(AGE_STORAGE_KEY, '1');
    } catch (e) {
        // ignore
    }
}

const MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];

const DAYS = Array.from({ length: 31 }, (_, i) => i + 1);

const currentYear = new Date().getFullYear();
const YEARS = Array.from({ length: currentYear - 1899 }, (_, i) => currentYear - i);

const useStyles = makeStyles((theme) => ({
    root: {
        margin: theme.spacing(2, 0, 3),
        textAlign: "center",
    },
    lightBulb: {
        verticalAlign: 'middle',
        marginRight: theme.spacing(1),
    },
    select: {
        margin: theme.spacing(0, 1),
        padding: theme.spacing(1),
        fontSize: '1rem',
        borderRadius: '8px',
    },
}));

export default function AgeChecker(props) {
    const { setAge } = props;
    const classes = useStyles();
    const [month, setMonth] = React.useState("");
    const [day, setDay] = React.useState("");
    const [year, setYear] = React.useState("");
    const formHandler = () => {
        const today = new Date();
        const birthDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        if (age < 18) {
            window.location.href = 'https://www.crazygames.com/';
        } else {
            rememberAgeVerified();
            setAge(age);
        }
    }
    return (
      <Box className={classes.root}>
        Age Verification
        <p>This website is intended for an 18+ audience. Please enter your date of birth to continue.</p>
        <form>
            <select className={classes.select} value={month} onChange={(e) => setMonth(e.target.value)}>
                <option value="">Month</option>
                {MONTHS.map((name, index) => (
                    <option key={name} value={index + 1}>{name}</option>
                ))}
            </select>
            <select className={classes.select} value={day} onChange={(e) => setDay(e.target.value)}>
                <option value="">Day</option>
                {DAYS.map((d) => (
                    <option key={d} value={d}>{d}</option>
                ))}
            </select>
            <select className={classes.select} value={year} onChange={(e) => setYear(e.target.value)}>
                <option value="">Year</option>
                {YEARS.map((y) => (
                    <option key={y} value={y}>{y}</option>
                ))}
            </select>
            <Button onClick={formHandler}>Submit</Button>
        </form>
      </Box>
    );
  }
  